var FrameInitializer = function () {
    let obj = {};
    obj.frame_obj = null;
    obj.container = null;
    obj.csrf_token = null;
    obj.key = null;
    obj.field_name = null;
    obj.proportions = null;
    obj.frame_result_obj = null;
    obj.frame_rotate_obj = null;
    obj.$placeholder = null;
    obj.$frameContainer = null;
    obj.$deleteBtn = null;
    obj.$resultBtn = null;

    function popupResult(result) {
        var html;
        if (result.html) {
            html = result.html;
        }
        if (result.src) {
            html = '<img src="' + result.src + '" />';
        }
        Swal.fire({
            title: "Podgląd",
            html: html,
            allowOutsideClick: true,
            confirmButtonText: "Zamknij",
            customClass: {
                htmlContainer: "swal-large-text",
            },
        });
    }

    function initCroppie() {
        if (obj.frame_obj) {
            return;
        }
        obj.frame_obj = new Croppie(obj.container, {
            viewport: {
                width: obj.proportions.width,
                height: obj.proportions.height,
            },
            boundary: { width: "auto", height: 500 },
            showZoomer: true,
            enableOrientation: true,
            mouseWheelZoom: "ctrl",
            maxZoom: 3,
        });

        obj.frame_rotate_obj.off("click").on("click", function (ev) {
            ev.preventDefault();
            const deg = parseInt($(this).data("deg"));
            const current = obj.frame_obj.get();

            obj.frame_obj.rotate(deg);

            obj.frame_obj.bind({
                url: current.url,
                zoom: current.zoom,
                points: current.points,
            });
        });

        obj.frame_result_obj.off("click").on("click", function (ev) {
            ev.preventDefault();
            obj.frame_obj.result({ type: "blob" }).then(function (blob) {
                popupResult({
                    src: window.URL.createObjectURL(blob),
                });
            });
        });
    }

    function showCroppie() {
        obj.$placeholder.hide();
        obj.$frameContainer.show();
        obj.$deleteBtn.show();
        obj.$uploadBtn.hide();
        obj.$resultBtn.show();
    }

    function showPlaceholder() {
        obj.$placeholder.show();
        obj.$frameContainer.hide();
        obj.$deleteBtn.hide();
        obj.$uploadBtn.show();
        obj.$resultBtn.hide();

        if (obj.frame_obj) {
            obj.frame_obj.destroy();
            obj.frame_obj = null;
        }
    }

    function intializeFull(
        csrf_token,
        key,
        field_name,
        frame_result_obj,
        frame_rotate_obj,
        frame_upload_obj,
        upload_btn_obj,
        delete_btn_obj,
        frame_container_id,
        proportions
    ) {
        obj.container = document.getElementById(frame_container_id);
        obj.csrf_token = csrf_token;
        obj.key = key;
        obj.field_name = field_name;
        obj.proportions = proportions;
        obj.frame_result_obj = frame_result_obj;
        obj.frame_rotate_obj = frame_rotate_obj;
        obj.frame_upload_obj = frame_upload_obj;

        const $box = $(obj.container).closest(".fileframeajax_content");
        obj.$placeholder = $box.find(".frame_placeholder");
        obj.$loadingText = $box.find(".frame_placeholder_loading");
        obj.$frameContainer = $(obj.container);
        obj.$uploadBtn = $(upload_btn_obj);
        obj.$deleteBtn = $(delete_btn_obj);
        obj.$resultBtn = $box.find(".frame_result");

        obj.$deleteBtn.off("click").on("click", function (ev) {
            ev.preventDefault();

            if (!obj.current_file || !obj.frame_obj) {
                return;
            }

            Swal.fire({
                title: "Usuń zdjęcie",
                text: "Czy na pewno chcesz usunąć zdjęcie?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Usuń",
                cancelButtonText: "Anuluj",
            }).then(function (result) {
                if (!result.isConfirmed) {
                    return;
                }

                $.ajax({
                    url:
                        "/pioro/myform2/image-frame/" +
                        obj.key +
                        "/" +
                        obj.field_name +
                        "/remove/" +
                        obj.current_file.encoded_name,
                    type: "GET",
                    headers: {
                        "x-csrf-token": csrf_token,
                    },
                    success: function () {
                        obj.frame_obj.file_name = null;
                        obj.current_file = null;
                        obj.container.dispatchEvent(new Event("delete"));
                        showPlaceholder();
                    },
                    error: function () {
                        Swal.fire(
                            "Błąd",
                            "Wystąpił błąd podczas usuwania zdjęcia.",
                            "error"
                        );
                    },
                });
            });
        });

        frame_upload_obj.off("change").on("change", function () {
            const input = this;
            if (!input.files || !input.files[0]) {
                return;
            }

            let formData = new FormData();
            formData.append("file", input.files[0]);
            input.value = "";
            obj.$loadingText.show();

            $.ajax({
                url:
                    "/pioro/myform2/image-frame/" +
                    obj.key +
                    "/" +
                    obj.field_name +
                    "/file_upload_dropbox",
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                headers: {
                    "x-csrf-token": csrf_token,
                },
                success: function (response) {
                    obj.$loadingText.hide();
                    if (response.status === "success") {
                        initCroppie();
                        showCroppie();

                        obj.frame_obj.bind({
                            url: response.full_image_coded,
                        });
                        obj.frame_obj.file_name = response.full_name;
                        obj.current_file = response;
                    } else {
                        alert(response.info);
                    }
                },
            });
        });
    }

    function init(
        csrf_token,
        key,
        field_name,
        frame_result_obj,
        frame_rotate_obj,
        frame_upload_obj,
        upload_btn_obj,
        delete_btn_obj,
        frame_container_id,
        proportions
    ) {
        intializeFull(
            csrf_token,
            key,
            field_name,
            frame_result_obj,
            frame_rotate_obj,
            frame_upload_obj,
            upload_btn_obj,
            delete_btn_obj,
            frame_container_id,
            proportions
        );
    }

    function setImageName(file_name) {
        if (obj.frame_obj) {
            obj.frame_obj.file_name = file_name;
        }
    }

    function setCurrentFile(file) {
        obj.current_file = file;
    }

    function setImageUrl(url, options = null) {
        initCroppie();
        showCroppie();

        obj.frame_obj.bind({
            url: url,
            ...(options || {}),
        });
    }

    function updateEvent(func) {
        obj.container.addEventListener("update", function () {
            if (!obj.frame_obj || !obj.current_file) {
                return;
            }
            obj.frame_obj.result({ type: "base64" }).then(function () {
                func({
                    croppie_options: obj.frame_obj.get(),
                    full_path: obj.current_file.full_path,
                    file_name: obj.current_file.full_name,
                });
            });
        });
    }

    function deleteEvent(func) {
        obj.container.addEventListener("delete", function () {
            func();
        });
    }

    return {
        init,
        setImageName,
        setImageUrl,
        updateEvent,
        deleteEvent,
        setCurrentFile,
    };
};
